import React, {Component} from "react";
import Section from "./layouts/Section";
import {Link} from "react-router-dom";
import BigButton from "./layouts/BigButton";

class DeviceRepair extends Component {
    render() {
        return (
            <Section title={'Device Repair'}>
                <section className="section page-content">
                    <div className="container">
                        {/* First row - visible only on md and up */}
                        <div className="d-none d-md-block">
                            <div className="row justify-content-center mb-4">
                                <div className="col-md-4 px-4 d-flex justify-content-end">
                                    <Link to="/mobile-repair" style={{ width: '400px' }}>
                                        <BigButton 
                                            text="Mobile Repairs" 
                                            size="400px" 
                                            appearance="large"
                                            style={{ 
                                                background: 'url(assets/images/repair.jpg) no-repeat center/cover',
                                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                                                color: 'white'
                                            }}
                                        />
                                    </Link>
                                </div>
                                <div className="col-md-4 px-4 d-flex justify-content-start">
                                    <Link to="/pc-laptop-repair" style={{ width: '400px' }}>
                                        <BigButton
                                            text="PC/Laptop Repairs"
                                            size="400px"
                                            appearance="large"
                                            style={{ 
                                                background: 'url(assets/images/macbanner.jpg) no-repeat center/cover',
                                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                                                color: 'white'
                                            }}
                                        />
                                    </Link>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-md-4 px-4 d-flex justify-content-center">
                                    <Link to="/game-repair" style={{ width: '400px' }}>
                                        <BigButton 
                                            text="Game Console Repairs" 
                                            size="400px" 
                                            appearance="large"
                                            style={{ 
                                                background: 'url(assets/images/consolebanner.jpg) no-repeat center/cover',
                                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                                                color: 'white'
                                            }}
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* Mobile layout - visible only on sm and down */}
                        <div className="d-md-none">
                            <div className="d-flex flex-column align-items-center">
                                <div className="mb-4">
                                    <Link to="/mobile-repair" style={{ width: '400px' }}>
                                        <BigButton 
                                            text="Mobile Repairs" 
                                            size="400px" 
                                            appearance="large"
                                            style={{ 
                                                background: 'url(assets/images/repair.jpg) no-repeat center/cover',
                                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                                                color: 'white'
                                            }}
                                        />
                                    </Link>
                                </div>
                                <div className="mb-4">
                                    <Link to="/pc-laptop-repair" style={{ width: '400px' }}>
                                        <BigButton
                                            text="PC/Laptop Repairs"
                                            size="400px"
                                            appearance="large"
                                            style={{ 
                                                background: 'url(assets/images/macbanner.jpg) no-repeat center/cover',
                                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                                                color: 'white'
                                            }}
                                        />
                                    </Link>
                                </div>
                                <div>
                                    <Link to="/game-repair" style={{ width: '400px' }}>
                                        <BigButton 
                                            text="Game Console Repairs" 
                                            size="400px" 
                                            appearance="large"
                                            style={{ 
                                                background: 'url(assets/images/consolebanner.jpg) no-repeat center/cover',
                                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                                                color: 'white'
                                            }}
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Section>
        )
    }
}

export default DeviceRepair;